import React, { Component, useState, useEffect } from 'react'
import { withTranslation, Trans } from 'react-i18next';
import OfflineDb from '../../db'
import Grid from '@material-ui/core/Grid';
import classes from '../../App.module.css'
import { apiServices } from '../../services/apiServices';
import {useHistory} from "react-router-dom";
import {useGlobalSpinnerActionsContext} from '../../context/GlobalSpinnerContext'
function DataEntry() {
    const [dataSets, setDataSets] = useState(null)
    const [surveyMetaData, setSurveyMetaData] = useState(null)
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const history = useHistory();


    async function fetchDataFromDataBase() {
        let dataset = await OfflineDb.getDataFromPouchDB('dataEntrySet')
        setDataSets(dataset.data.dataSets)
    }

    useEffect(() => {
        fetchDataFromDataBase()
    }, [])

    function onDataSetClick(dataSetId) {
        
        const getDataOfSurveyApi = 'dataSets/'+dataSetId+'?fields=all,attributeValues[:all,attribute[id,name,displayName]],dataSetElements[id,dataSet[id],dataElement[:all,id,displayName,categoryCombo[id,displayName]],categoryCombo[id,displayName]],indicators[id,displayName,categoryCombo[id,displayName]],organisationUnits[id,path],sections[:all,dataElements[id,displayName],categoryCombos[id,displayName],,greyedFields[categoryOptionCombo[id,displayName],dataElement[id,displayName]]]'
        setGlobalSpinner(true)
        apiServices.getAPI(getDataOfSurveyApi)
        .then(getDataOfSurvey => {
            OfflineDb.setDataIntoPouchDB('surveyFormData', getDataOfSurvey.data)
            OfflineDb.setDataIntoPouchDB('currentDataSet', dataSetId)
            .then(res => {
                setGlobalSpinner(false)
                history.push('/layout/survey')
            })
        })
        .catch(err => {
            setGlobalSpinner(false)
        })
    }

    function createGrids() {
        return (
            dataSets.map(dataSet => {
                return (
                    <div className="homemenudivcontainer regformsubmitbtn">
                        <Grid container spacing={3}  sm={12} md={12} lg={12} className="" onClick={() => onDataSetClick(dataSet.id)}>
                            {/* <Grid item xs={3} sm={3} md={3} lg={4}>
                                <p className="homemenulinkicon"><FontAwesomeIcon icon={menuItems.icon} /></p>
                            </Grid> */}
                            <Grid item xs={12} sm={12} md={12} lg={12} className="vert-center">
                                <p className="homemenuname"><Trans>{dataSet.displayName}</Trans></p>
                            </Grid>
                        </Grid>
                    </div>
                )
            })
        )
    }

    return (
        <div className={classes.container}>
            <main style={{ display: 'flex', height: '100%', width: '100%' }}>
                <section className="homepagebgsection"
                    style={{
                        flexGrow: 1,
                        padding: 20,
                        background: '#fff'
                    }}
                >
                    <Grid container spacing={3} className="mt-80px">
                        <Grid item xs={12}>
                            <Grid container sm={12} md={12} lg={12} spacing={3} className="progresscontainer homemenuholder">
                                {dataSets != null 
                                ? 
                                    createGrids()
                                :
                                    <> </>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </section>
            </main>
        </div>
    )
}

export default DataEntry